<template>
  <div style="">
    <div style="height: 100%" v-if="model === false">
      <div class="layer1" @click="changevisibleother">
        <div style="display:flex;position: absolute;height: 100%">
          <div class="leftLayer" @click="back"></div>
        </div>
        <div class="rightLayer">
          <!--        <div class="communicitynet" @click="commyintroduce">-->
          <!--          &lt;!&ndash;          <div class="net"></div> &nbsp;&nbsp;&ndash;&gt;-->
          <!--          公司简介</div>-->

          <!--        <div class="communicityFeedback" @click="feedback">-->
          <!--&lt;!&ndash;          <div class="net"></div> &nbsp;&nbsp;&ndash;&gt;-->
          <!--          服务反馈</div>-->
          <div class="communicityGPT" style="color: black" @click="back">首页</div>
          <div class="communicityGPT" style="color: black" @click="feedback">服务反馈</div>
          <!--          <div class="communicity" @click="show">诚邀合作</div>-->

          <div v-if="userId" class="loginUser">
            <div style="display: flex">
              <el-dropdown class="userInfo">
                <div class="el-dropdown-link" style="display: flex; align-items: center">
                  <el-avatar :size="30" :src="avator" class="avator"></el-avatar>
                  <div class="userName">
                    <span></span>
                    {{ userName }}
                  </div>
                </div>

                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item class="hoverItem"
                    style="display: flex; height:32px;text-align: left;font-size: 1vw;font-family: arial, sans-serif, 'Microsoft Yahei'">
                    <router-link class="flex" style="display: flex" to="/userInformation">
                      <div>
                        <img alt="" class="icon not" src="@/assets/userIcon.png"
                          style="width: 20px; height: 20px; margin: 7px 10px auto 0" />
                      </div>
                      <span style="margin-top: 0;font-size: 14px;width: 80px">个人中心</span>
                      <span style="position: absolute;right:5px;margin-left: 10px;font-size: 12px"><i
                          class="el-icon-arrow-right"></i></span>
                    </router-link>
                  </el-dropdown-item>
                  <el-dropdown-item
                    style="display: flex; height:32px;text-align: left;font-size: 1vw;font-family: arial, sans-serif, 'Microsoft Yahei'"
                    @click.native="outLogin()">
                    <img alt="" class="icon hover" loading="lazy" src="@/assets/outHoverIcon.png"
                      style="width: 20px; height: 20px; margin: 7px 10px auto 0" />

                    <span style="margin-top: 0;font-size: 14px;width: 80px">退出登录</span>
                    <span style="position: absolute;right:5px;margin-left: 10px;font-size: 12px"><i
                        class="el-icon-arrow-right"></i></span>

                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div v-else class="login" style="color: black" @click="login">登录/注册</div>
          <div class="communicitynet">
            <el-dropdown @command="handleCommand" style="font-size: 1vw;font-weight: bolder">
              <span class="el-dropdown-link" style="color: black">
                中文<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" style="margin-top: 3vh">
                <el-dropdown-item command="EN"
                  style="font-weight: bolder;font-size: 1vw;z-index: 9999999999999">EN</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <div class="N2" @click="opOpenClaw">
        <div style="margin: auto;color: black">
          <img class="openclaw-logo" src="@/assets/openclaw/openclaw.png" alt="">云上养虾
        </div>
      </div>
      <div class="N1" @click="opAssistant">
        <div style="margin: auto;color: black">
          提效AI工具
        </div>
      </div>
      <div style="position: absolute;right: 0;top: 0;width: 10vw;height: 100%;z-index: 100;display: flex">
        <div
          style=" color:black;position: absolute;top: 50%;transform: translateY(-50%);font-size: 0.8vw;display: flex;align-items: center;font-weight: bolder;font-family: Sora">
          预览模式 &nbsp;&nbsp;&nbsp;
          <el-switch v-model="moveSwitch" @change="start" active-color="#13ce66" inactive-color="#ff4949">
          </el-switch>
        </div>
      </div>
      <el-popover placement="bottom" popper-class="down-popover" trigger="manual" width="900" v-model="visible">
        <div style="width: 100%;padding: 1vh 3vw;">
          <el-input v-model="keyWords" style=" border: 1px solid black;border-radius: 9px" placeholder="请输入"
            @input="getSearch"></el-input>
        </div>
        <div v-if="search.length > 0" class="searchBack" style="  height: 50vh;
  overflow-y: auto;">
          <li v-for="item in search" :key="item">
            <div class="searchContent" @click="routerSkip(item.link)">
              <div class="title1" v-html="item.title"></div>
              <div class="title2" v-html="item.contend"></div>
            </div>

          </li>

        </div>
        <div v-else class="searchBackno">
          暂未检索到您要查找的关于<span style="color: #eb7c31;margin: 0 0.5vw">“{{ keyWords }}”</span>的信息，换个关键词试试吧！
        </div>
        <div slot="reference" class="search" @click="changevisible">
          <el-input v-model="keyWords" style="border: none" placeholder="请输入您要查找的GPT或内容关键词"
            @input="getSearch"></el-input>
          <i class="el-icon-search"
            style="margin-right: 0.8vw;z-index: 999999999;font-size: 1vw;color:gray;font-weight: bold;height: 5vh;display: flex;align-items: center"></i>
        </div>
      </el-popover>

      <div v-if="GptVisible" style="position: fixed;width: 100%;height: 100%;background-color: rgba(128, 128, 128, 0.5);top:0;left: 0;z-index: 9999999">
        <div class="gptassistent" style="position: fixed;;top:50%;left: 50%;transform: translateY(-50%) translateX(-50%);width: 65%;height: 70%;overflow-y: scroll">
          <GPTAssistants></GPTAssistants>
        </div>
        <img @click="GptVisible=false" style="height:2vw;width:2vw;position:fixed;right: 20vw;top: 20%;z-index: 30" src="@/assets/error.png">
      </div>

      <div v-if="OpenClawVisible" style="position: fixed;width: 100%;height: 100%;background-color: rgba(128, 128, 128, 0.5);top:0;left: 0;z-index: 9999999">
        <div class="gptassistent" style="position: fixed;;top:50%;left: 50%;transform: translateY(-50%) translateX(-50%);width: 65%;height: 70%;overflow-y: scroll">
          <OpenClaw></OpenClaw>
        </div>
        <img @click="OpenClawVisible=false" style="height:2vw;width:2vw;position:fixed;right: 20vw;top: 20%;z-index: 30" src="@/assets/error.png">
      </div>
    </div>
    <div v-else>
      <div class="layerModel">
        <div v-if="showsearch" class="searchnew">
          <div style="float: right;margin: 15px"><i class="el-icon-circle-close"
              style="font-size: 20px;font-weight:bold;color: #163eee" @click="showsearch = false"></i></div>
          <div class="search">
            <el-input v-model="keyWords" style="border: none" placeholder="请输入您要查找的GPT或内容关键词"
              @input="getSearch"></el-input>
            <i class="el-icon-search"
              style="margin-right: 15px;z-index: 999999999;font-size: 16px;color:gray;font-weight: bold;height: 45px;display: flex;align-items: center;justify-content: center"></i>
          </div>
          <div v-if="search.length > 0" class="searchBack">
            <li v-for="item in search" :key="item">
              <div class="searchContent" @click="routerSkip(item.link)">
                <div class="title1" v-html="item.title"></div>
                <div class="title2" v-html="item.contend"></div>
              </div>
            </li>
          </div>
          <div v-else class="searchBackno">
            暂未检索到您要查找的关于<span style="color: #eb7c31;margin: 0 0.5vw">“{{ keyWords }}”</span>的信息<br>换个关键词试试吧！
          </div>
        </div>
        <div class="leftLayer" @click="back"></div>
        <div class="rightLayer">
          <div class="openclaw-box" @click="openClawClick">
            <img class="openclaw-logo" src="@/assets/openclaw/openclaw.png" alt="">云上养虾
          </div>
          <div v-if="userId" class="loginUser">
            <div style="display: flex">
              <div class="login" style="margin-right: -10px" @click="showsearch = true"><i style="color: black"
                  class="el-icon-search" /></div>
              <!-- <div class="communicitynet">
                <div class="net"></div> &nbsp;&nbsp;
                <el-dropdown @command="handleCommand" style="font-size: 1vw;font-weight: bolder">
                  <span class="el-dropdown-link" style="font-size: 14px;color: black;margin:0px 0px 0px 10px">
                    中文<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="EN" style="font-size: 14px;color: black;">EN</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div> -->
              <el-dropdown class="userInfo">
                <div class="el-dropdown-link" style="display: flex; align-items: center">
                  <el-avatar :size="30" :src="avator" class="avator"></el-avatar>
                  <div class="userName">
                    <span></span>
                    {{ userName }}
                  </div>
                </div>

                <el-dropdown-menu slot="dropdown">

                  <el-dropdown-item class="hoverItem"
                    style="display: flex; height:32px;text-align: left;font-size: 12px;font-family: arial, sans-serif, 'Microsoft Yahei'">
                    <router-link class="flex" style="display: flex" to="/infoMobile">
                      <div>
                        <img alt="" class="icon not" src="@/assets/userIcon.png"
                          style="width: 20px; height: 20px; margin: 7px 5px auto 0" />
                      </div>
                      <span style="margin-top: 0">个人中心</span>
                      <span style="position: absolute;right:0px;margin-left: 10px;font-size: 12px"><i
                          class="el-icon-arrow-right"></i></span>
                    </router-link>
                  </el-dropdown-item>

                  <el-dropdown-item style="display: flex; text-align: left;font-size: 12px;height: 32px"
                    @click.native="outLogin()">
                    <img alt="" class="icon hover" loading="lazy" src="@/assets/outHoverIcon.png"
                      style="width: 20px; height: 20px; margin: auto 5px auto 0" />
                    退出登录
                    <span style="position: absolute;right:0px;margin-left: 10px;font-size: 12px"><i
                        class="el-icon-arrow-right"></i></span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown>
                <div class="el-dropdown-link" style="display: flex; align-items: center">
                  <img :src="three" class="communicitynet"
                    style="height: 23px;width: 20px;border-radius:0;display: flex;justify-content: center;align-items: center">
                </div>

                <el-dropdown-menu slot="dropdown">

                  <el-dropdown-item class="hoverItem"
                    style="display: flex; height:32px;text-align: left;font-size: 12px;font-family: arial, sans-serif, 'Microsoft Yahei'">
                    <div @click="show">
                      <span style="margin-top: 0">诚邀加盟</span>
                    </div>
                  </el-dropdown-item>

                  <el-dropdown-item style="display: flex; text-align: left;font-size: 12px;height: 32px">
                    <div @click="gpts">GPT社区</div>


                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div v-else style="display: flex">
            <div class="login" style="margin-right: -10px" @click="showsearch = true"><i style="color: black"
                class="el-icon-search" /></div>
            <!-- <div class="communicitynet" style="margin-top: -1px;margin-right: -5px;color: black">
              <el-dropdown @command="handleCommand" style="font-size: 1vw;font-weight: bolder">
                <span class="el-dropdown-link" style="font-size: 14px;color: black;margin:0px 0px 0px 10px">
                  中文<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="EN" style="font-size: 14px;color: black;">EN</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div> -->
            <div class="login" style="color: black" @click="login">登录/注册</div>
            <el-dropdown>
              <div class="el-dropdown-link" style="display: flex; align-items: center">
                <img :src="three" class="communicitynet"
                  style="height: 23px;width: 20px;border-radius:0;display: flex;justify-content: center;align-items: center">
              </div>

              <el-dropdown-menu slot="dropdown" style="text-align: right">

                <el-dropdown-item class="hoverItem"
                  style="display: flex; height:32px;text-align: left;font-size: 12px;font-family: arial, sans-serif, 'Microsoft Yahei'">
                  <div @click="show">
                    <span style="margin-top: 0">诚邀加盟</span>
                  </div>
                </el-dropdown-item>

                <el-dropdown-item style="display: flex; text-align: left;font-size: 12px;height: 32px">
                  <div @click="gpts">GPT社区</div>


                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <!--       油气通GPT 全球油气行业最专业的、开放的大模型人工智能云平台-->
    </div>

    <partnerTip :dialogVisible="dialogconsult" @hideDialog="hide"></partnerTip>
  </div>
</template>


<script>
import {
  // logOut,
  // userDetail,
  // getAuthorize,
  // getLoginStatus,
  // deleteUserAgent,
} from "@/api/user";
import Fingerprint2 from "fingerprintjs2";
import PartnerTip from "@/components/partnerTip.vue";
import GPTAssistants from "@/views/components/GPTAssistants.vue";
import OpenClaw from "@/views/components/OpenClaw.vue";
import {loginout,
  getUserInfo
} from "@/api/login";
export default {
  name: "headtip",
  props: {
    changeVisable: {
      type: Number,
      required: true
    },
  },
  components: { 
    PartnerTip,
    OpenClaw,
    GPTAssistants,
  },
  data() {
    return {
      GptVisible:false,
      OpenClawVisible: false,
      moveSwitch: false,
      // eslint-disable-next-line vue/no-dupe-keys
      // changeVisable: 1,
      keyTitle: "",
      model: false,
      showsearch: false,
      keyWords: "",
      three: require("@/assets/three.png"),
      visible: 0,
      value: '选项2',
      options: [{
        value: '选项1',
        label: 'EN'
      }, {
        value: '选项2',
        label: '中文'
      },],
      search: [
        {
          link: "gptTranslate",
          title: "生产工艺优化GPTs",
          contend: "生产工艺优化GPTs，不仅有助于提高开发效果和采收率，同时降低开发过程中的风险损失，确保油气田的安全稳定开发"
        },
        {
          link: "gptTranslate",
          title: "解释类GPTs",
          contend: "解释类GPTs，基于油气开发目标解释，不仅有助于工程作业人员实时掌握油气藏地质地质条件以及工程作业情况，还为开发过程中的决策和调整提供了有力支持安全稳定开发"
        },
        {
          link: "gptTranslate",
          title: "生产工艺优化GPTs",
          contend: "生产工艺优化GPTs，不仅有助于提高开发效果和采收率，同时降低开发过程中的风险损失，确保油气田的安全稳定开发"
        },
        {
          link: "gptTranslate",
          title: "解释类GPTs",
          contend: "解释类GPTs，基于油气开发目标解释，不仅有助于工程作业人员实时掌握油气藏地质地质条件以及工程作业情况，还为开发过程中的决策和调整提供了有力支持安全稳定开发"
        },
        {
          link: "gptTranslate",
          title: "生产工艺优化GPTs",
          contend: "生产工艺优化GPTs，不仅有助于提高开发效果和采收率，同时降低开发过程中的风险损失，确保油气田的安全稳定开发"
        },
        {
          link: "gptTranslate",
          title: "解释类GPTs",
          contend: "解释类GPTs，基于油气开发目标解释，不仅有助于工程作业人员实时掌握油气藏地质地质条件以及工程作业情况，还为开发过程中的决策和调整提供了有力支持安全稳定开发"
        },
      ],
      userName: localStorage.getItem("gptsUserName"),
      avator: require("@/assets/user.jpg"),
      userId: localStorage.getItem("gptsUserId"),
      token: localStorage.getItem("token"),
      // gptsUserId: localStorage.getItem("gptsUserId"),
     
      userInfo: "",
      // userId:48,
      dialogconsult: false,
      baseURL: this.$utils.baseURL,
      baseURLEN: this.$utils.baseURLEN,
    };
  },
  created() {
    // console.log("changeVisable", this.changeVisable);
    this.getSearch()

  },
  watch: {
    "$store.state.userId"(newValue, oilValue) {
      this.userId = newValue;
      if (newValue && newValue != oilValue) {
        this.getUser();
        this.ifComplete()
      }
    },

    "changeVisable"() {
      console.log(this.visible, "visible");
      // this.changeVisable = newValue;
      if (this.visible === 1) {
        this.visible = 0
      }
      // console.log("子组件", this.changeVisable);
    },
  },
  mounted() {
    const screenWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    const screenHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;

    // Log the values1731 809   1653 834   1912 932
    console.log("Screen Width: ", screenWidth);
    console.log("Screen Height: ", screenHeight);
    if (screenWidth <= 700) {
      this.model = true;
    } else {
      this.model = false;
    }
    let murmur;
    let that = this;
    var options = {
      excludes: {
        enumerateDevices: true,
        platform: true,
        addBehavior: true,
        cpuClass: true,
        deviceMemory: true,
        hardwareConcurrency: true,
        colorDepth: true,
        screenResolution: true,
        availableScreenResolution: true,
        indexedDb: true,
        webgl: true,
        plugins: true,
        canvas: true,
        pixelRatio: true,
      },
    };
    console.log(options, "options");
    Fingerprint2.get(options, (components) => {
      const values = components.map(function (component, index) {
        if (index === 0) {
          return component.value.replace(/\bNetType\/\w+\b/, "");
        }
        return component.value;
      });
      murmur = Fingerprint2.x64hash128(values.join(""), 31);
      that.murmur = murmur;
      localStorage.setItem("murmur", murmur);
      // that.isLogin();
    });
    this.userId = localStorage.getItem("gptsUserId");
    this.getUser();
    // if (this.userId) {
    //   this.getUser();
    //   // this.ifComplete()
    // }
  },
  methods: {
    openClawClick(){
      window.open("/openClawMobile")
    },
    opAssistant() {
      try {
        this.GptVisible = true
      } catch (e) {
        console.log(e)
      }

    },
    opOpenClaw(){
      try {
        this.OpenClawVisible = true
      } catch (e) {
        console.log(e)
      }
    },
    start() {
      // console.log("hahahahahah------------")
      this.$emit("startAutoScroll", true)
    },
    handleCommand(command) {
      if (command == 'EN') {
        // window.open(this.baseURL, "_blank");
        if (this.$route.name == 'Home') {
          window.open(this.baseURLEN, "_blank");
        }
        else if (this.$route.name == 'feedback') {
          window.open(this.baseURLEN + "/feedbackEn", "_blank");
        }
        else {
          window.open(this.baseURLEN + "/" + this.$route.name, "_blank");
        }
      }
    },
    // changeheadVisable() {
    //   if (this.changeVisable === 1) {
    //     this.changeVisable = 0
    //   }
    //   else {
    //     this.changeVisable = 1
    //   }
    //   console.log("父组件", this.changeVisable)
    // },
    changevisible() {
      if (this.visible === 0) {
        this.visible = 1
      }
      else {
        this.visible = 1
      }
    },
    changevisibleother() {
      if (this.visible === 1) {
        this.visible = 0
      }

    },
    getSearch() {
      console.log(this.search.length)
      this.$axios
        .get("https://cn.oilgasgpts.com/search/getThirdByName_Introduce?keyword=" + this.keyWords, {
          // .get("http://192.168.200.50:16542/search/getThirdByName_Introduce?keyword=" + this.keyWords, {
          headers: {
            Authorization: "eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6IjUyNjZiN2QxLTNhOWUtNDBiOC05MGJlLTNjMTU1OGM3YmI3YiJ9.OsIDjD4UL8AZHu5j5KO-26IQwJu6uVvu59KNM18vuLmjzXMJFl-lX2vyyw_4L1AXC6wot6lpxhv_JZUVe1LokQ",
          },
        })
        .then((res) => {
          console.log("search", res.data)
          this.search = []
          var searchdata = res.data.data.thirdPageList

          searchdata.forEach((item, index) => {
            if (res.data.data.keywordList[0] !== "") {
              item.leighttitle = this.highlightText(item.title, res.data.data.keywordList);
              item.leightcontend = this.highlightText(item.introduce, res.data.data.keywordList);
              this.$set(this.search, index, {
                link: item.url,
                title: item.leighttitle,
                contend: item.leightcontend,
              });
            }
            else {
              this.$set(this.search, index, {
                link: item.url,
                title: item.title,
                contend: item.introduce,
              });
            }
          })
          console.log("成都", this.search.length)
        })
        .catch((err) => {
          console.log(err);
        });
    },
    highlightText(text, keywords) {
      const regex = this.createHighlightRegex(keywords);
      return text.replace(regex, (match) => `<span style="color: #eb7c31">${match}</span>`);
    },
    createHighlightRegex(keywords) {
      const escapedKeywords = keywords.map(keyword => keyword.replace(/[/\\^$*+?.()|[\]{}]/g, '\\$&'));
      const regexPattern = escapedKeywords.join('|');
      return new RegExp(regexPattern, 'gi');
    },
//     ifComplete() {
//     getUserInfo1(this.userId)
//     .then((res) => {
//       if (res.data.msg == "信息已完善") {
//         localStorage.setItem("infoComplete", 1);
//       } else {
//         localStorage.setItem("infoComplete", 0);
//       }
//       console.log("用户信息完善状态:", res.data);
//     })
//     .catch((err) => {
//       console.error("检查用户信息完善状态失败:", err);
//       // 可以根据需要设置默认值
//       localStorage.setItem("infoComplete", 0);
//     });
// },
    // ifComplete() {
    //   this.$axios
    //     .get("/info/gpts_user/judgment_info/" + this.userId)
    //     .then((res) => {
    //       if (res.data.msg == "信息已完善") {
    //         localStorage.setItem("infoComplete", 1)
    //       } else {
    //         localStorage.setItem("infoComplete", 0)
    //       }

    //       console.log("--------ren", res.data)

    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });

    // },
    // isLogin() {
    //   let murmur = localStorage.getItem("murmur");
    //   let idass = this.$store.state.idass;
    //   let data;
    //   console.log(idass, "idass");
    //   if (idass && idass != "undefined") {
    //     data = {
    //       userAgent: murmur,
    //       idass: idass,
    //     };
    //   } else {
    //     data = {
    //       userAgent: murmur,
    //     };
    //   }
    //   // getLoginStatus(JSON.stringify(data))
    //   this.$axios
    //     .post("https://www.oilgasinfoai.com/auth/oauth/getLoginStatus", data)
    //     .then((res) => {
    //       console.log(res, "res11111");
    //       let options = this.$route.query;
    //       if (res.data.data.isLogin == true && this.$store.state.access_token) {
    //         this.getUser();
    //         this.ifComplete()
    //       } else if (
    //         res.data.data.isLogin == true &&
    //         !this.$store.state.access_token &&
    //         !options.code
    //       ) {
    //         this.login();
    //       } else if (
    //         res.data.data.isLogin == false &&
    //         res.data.data.type == 2
    //       ) {
    //         console.log("isLogin Flase type 2");
    //         //this.outLogin();
    //         localStorage.removeItem("userInfo");
    //         localStorage.removeItem("access_token");
    //         localStorage.removeItem("userId");
    //         localStorage.removeItem("typeInfo");
    //         localStorage.removeItem("access_tokenout");
    //         localStorage.removeItem("Zyaccess_token");
    //         localStorage.removeItem("idass");
    //         this.$store.state.access_token = "";
    //         this.$store.state.idass = "";
    //         this.$store.state.user = {};
    //         this.userId = "";
    //         this.userName = "";
    //       } else if (
    //         res.data.data.isLogin == false &&
    //         res.data.data.type == 1
    //       ) {
    //         console.log("isLogin Flase type 1");
    //         localStorage.removeItem("userInfo");
    //         localStorage.removeItem("access_token");
    //         localStorage.removeItem("userId");
    //         localStorage.removeItem("typeInfo");
    //         localStorage.removeItem("access_tokenout");
    //         localStorage.removeItem("Zyaccess_token");
    //         localStorage.removeItem("idass");
    //         this.userId = "";
    //         this.userName = "";
    //         this.$store.state.access_token = "";
    //         this.$store.state.idass = "";
    //         this.$store.state.user = {};
    //         this.login();
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
    getUser() {
      getUserInfo(this.userId).then((res) => {
        this.userInfo = res.data;
        console.log("用户信息", res.data);
        localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
        localStorage.setItem("userId", res.data.gptsUserId);
        this.$store.state.user = res.data;
        this.$store.state.userId = res.data.gptsUserId;
        this.userId = res.data.gptsUserId;
        this.userName = this.userInfo.gptsUserName;
        // this.ifComplete()
      });
    },
    outLogin(){
       loginout({browserId:localStorage.getItem("murmur")}).then((res) =>{
        if(res.code ==200){
          localStorage.removeItem("userId");
          localStorage.removeItem("userInfo");
           localStorage.removeItem("token");
          this.$message.success("退出登录成功")
          window.location.reload();
        }
       })
       .catch(()=>{
         this.$message.success("退出登录成功")
      //  this.$message.error("退出登录失败，请重试")
       })
       },
    // outLogin() {
    //   // localStorage.removeItem("userId");
    //   // window.location.reload();
    //   loginout()
    //     .then((res) => {
    //       localStorage.removeItem("userInfo");
    //       localStorage.removeItem("access_token");
    //       localStorage.removeItem("userId");
    //       localStorage.removeItem("typeInfo");
    //       localStorage.removeItem("access_tokenout");
    //       localStorage.removeItem("Zyaccess_token");
    //       localStorage.removeItem("idass");
    //       this.$store.state.access_token = "";
    //       this.$store.state.idass = "";
    //       this.$store.state.user = {};
    //       // deleteUserAgent(localStorage.getItem("murmur"))
    //       let data = {
    //         userAgent: localStorage.getItem("murmur"),
    //       };
    //       this.$axios
    //         .post(
    //           "https://www.oilgasinfoai.com/auth/oauth/deleteUserAgent",
    //           data
    //         )
    //         .then(() => {
    //           localStorage.removeItem("murmur");
    //           window.location.href = res.data;
    //         });
    //     })
    //     .catch((error) => {
    //       console.error("退出登录失败:", error);
    //       this.$message.error("退出登录失败，请重试"); // 提示用户退出登录失败
    //       // 可以在此处执行其他的错误处理逻辑，例如重新加载页面或者显示其他提示信息
    //     });
    // },
    // login() {
    //   // this.$router.push("/login")
    //   // let href = "https://www.oilgasgpts.com/";
    //   let href = window.location.href.split("&code")[0];
    //   getAuthorize(href).then((res) => {
    //     window.location.href = res.data.url;
    //   });
    // },
    login(){
    this.$router.push("/loginnew")
    },
    back() {
      // alert(this.baseURL)
      // window.open(this.baseURL);
      window.location.href = '/';
    },
    routerSkip(link) {
      window.open(link, "_blank");
    },
    English() {
      const routeName = this.$route.name;

      console.log(routeName)
      if (this.value === "选项1") {
        if (routeName === "Home") {
          window.open(this.baseURLEN, "_blank");
        } else if (routeName === "feedback") {
          window.open(this.baseURLEN + "/feedbackEn", "_blank");
        } else {
          window.open(this.baseURLEN + "/" + routeName, "_blank");
        }

      }
      else {
        if (routeName === "Home") {
          window.open(this.baseURL, "_blank");
        }
        else if (routeName === "Privacy") {
          window.open(this.baseURL, "_blank");
        }
        else {
          window.open(this.baseURL + routeName, "_blank");
        }

      }
    },
    commyintroduce() {
      this.$router.push("/companyintroduce")
      // window.open("https://cnmall.antonoil.com/gpts_feedback", "_blank");
    },
    feedback() {
      this.$router.push("/feedback")
      // window.open("https://cnmall.antonoil.com/gpts_feedback", "_blank");
    },
    gpts() {
      window.open("https://www.oilgascommunity.com/sortList?id=39", "_blank");
    },
    show() {
      this.$emit("showDialog");
    },
    hide() {
      this.dialogconsult = false;
    },
  },
};
</script>

<style scoped lang="scss">
@keyframes shake {
  0%, 100% {
    transform: rotate(0);
  }
  10%, 30%, 50%, 70%, 90% {
    transform: rotate(-10deg);
  }
  20%, 40%, 60%, 80% {
    transform: rotate(10deg);
  }
}


.openclaw-box{
  font-family: Sarial, sans-serif, "Microsoft Yahei";
  font-size: 14px;
  color: #000;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 6px;
  .openclaw-logo{
    width: 26px;
    height: 26px;
    transform-origin: center bottom;
    animation: shake 2s infinite;
  }
}

.N1 {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 13vw;
  display: flex;
  cursor: pointer;
  width: fit-content;
  /* //background-color: #117cd1; */
  padding: 5px 0;
  font-size: 1vw;
  border-radius: 9px;
  color: black;
  font-weight: bolder;
  text-align: center;
  align-items: center;
  background-size: cover;
  
}
.N2 {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 21vw;
  display: flex;
  cursor: pointer;
  width: fit-content;
  /* //background-color: #117cd1; */
  padding: 5px 0;
  font-size: 1vw;
  border-radius: 9px;
  color: black;
  font-weight: bolder;
  text-align: center;
  align-items: center;
  background-size: cover;
  & > div{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }
  .openclaw-logo{
    width: 36px;
    height: 36px;
    transform-origin: center bottom;
    animation: shake 2s infinite;
  }
}

.down-popover {
  min-height: 8vh !important;
  max-height: 50vh !important;
  overflow: auto;
  padding: 0 !important;
  left: 10vw !important;
  background: linear-gradient(180deg, #f5f4f6, #e6ebf7) !important;
  box-shadow: 3px 0 8px 0px rgba(52, 48, 48, 0.8) !important;
  border: none !important;
}

.down-popover::-webkit-scrollbar-track-piece {
  background: linear-gradient(180deg, #f5f4f6, #e6ebf7);

}

.down-popover::-webkit-scrollbar {
  width: 6px;
  transition: all 2s;
}

.down-popover::-webkit-scrollbar-thumb {
  background-color: #bdbbbb;
  border-radius: 100px;
}

.down-popover::-webkit-scrollbar-thumb:hover {
  background-color: #bbb;
}

.down-popover::-webkit-scrollbar-corner {
  background: linear-gradient(180deg, #f5f4f6, #e6ebf7);
}

.el-popper[x-placement^="bottom"] .popper__arrow::after {

  margin-left: -50px !important;

  border-bottom-width: 0;

  border-top-color: rgb(250, 250, 250) !important;

}

.el-popper[x-placement^=bottom] .popper__arrow {
  left: 10vw !important;
  border-bottom-color: rgb(250, 250, 250) !important;
}

.el-dropdown-menu {
  top: 3vh !important;
  padding: 0 !important;
}

@media screen and (max-width: 757px) {

  .el-dropdown-menu__item,
  .el-menu-item {
    padding: 0 15px !important;
  }

  .el-popper[x-placement^=bottom] .popper__arrow {
    background-color: transparent !important;
    border-bottom-color: transparent !important;
  }

  .el-dropdown-menu {
    top: 40px !important;
    padding: 0 !important;
  }
}
</style>
<style lang="scss" scoped type="text/scss">
.avator {
  border: 2px solid #fff;
}

.searchBack {

  //background-color: rgba(102, 102, 102, 0.2);
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  column-gap: 1.5vw;
  row-gap: 2vh;
  padding: 3vh 2vw;
  list-style-type: none;
}

.searchBackno {
  display: flex;
  padding: 3vh 2vw;
  font-weight: bold;
  //justify-content: center;
  //align-items: center;
}

.searchContent {
  cursor: pointer;
  //background: #e5ebfa;
  border: white 1px solid;
  background-color: white;
  box-shadow: 5px 0 14px 0px #e5ebfa;
  padding: 2vh 1.5vw;
  height: 100%;
  border-radius: 9px;
  //color: white;

  .title1 {
    font-size: 1vw;
    font-weight: bold;
    line-height: 3.5vh;
  }

  .title2 {
    font-size: 0.8vw;
    line-height: 2.8vh;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    /* 限制在一个块元素显示的文本的行数 */
    overflow: hidden;
    text-overflow: ellipsis;
    height: 5.6vh;
  }
}

.searchContent:hover {
  border: #9b85f4 1px solid;


}

.search {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  left: 35vw;
  border-radius: 9px;
  width: 0;
  background-color: white;
  margin-left: 2vw;

  ::v-deep .el-input {
    border-radius: 9px;
    height: 5vh;
    width: 20vw;
    font-size: 0.8vw;
  }

  ::v-deep .el-input__inner {
    border-radius: 9px;
    height: 5vh !important;
    //border: white 1px solid !important;
    //background-color: transparent !important;
    background-color: transparent !important;
  }

}

::v-deep .el-input__inner {
  border-radius: 9px;
  height: 5vh !important;
  //border: white 1px solid !important;
  //background-color: transparent !important;
  background-color: transparent !important;
}

.userName {
  color: black;
  font-size: 1vw;
  line-height: 1.3;
  text-align: left;
  margin-left: 10px;
  max-width: 50px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.layer1 {
  width: fit-content;
  padding: 0vh 1vw 0 0;
  left: 3vw;
  height: 100%;
  z-index: 9;
  //position: fixed;
  display: flex;
  //justify-content: space-between;

  .leftLayer {
    cursor: pointer;
    width: 8.2790294627383vw;
    margin: auto;
    height: 5.56242274412855vh;
    background-image: url("../assets/Anvisionlogo.png");
    //background-image: url("../assets/GPTLOGO.png");
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    background-color: transparent;
    /* 这里设置背景颜色为透明 */
    //border: #2c3e50 1px solid;

  }

  .searchno {
    background-color: transparent;
    width: 50vw;
    height: 5vh;
    border-radius: 9px;
    margin-left: 2vw;
  }

  .rightLayer {
    width: fit-content;
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
    /* Vertically center the content */
    position: absolute;
    left: 50%;
    transform: translateX(-50%);

    .communicitynet {
      //z-index: 8;
      cursor: pointer;
      font-size: 1vw;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      font-weight: bold;
      //color: #2f6eff;
      color: white;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      /* Vertically center the content */
      //border-radius: 9.1px;
      padding: 2.46242274412855vh 0.5vw;
      height: 4.56242274412855vh;
      overflow: hidden;
      /* Add overflow property */
      display: flex;
      position: relative;

      .net {
        background-image: url("../assets/earth2.png");
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        background-color: transparent;
        /* 这里设置背景颜色为透明 */
        width: 20px;
        height: 20px;
        right: 5vw;

        position: absolute;
      }
    }

    .communicitynet:hover {
      //background: #bfd8f9;
      color: #2f6eff;
    }

    ::v-deep .el-select .el-input__inner {
      border-radius: 9px;
      background-color: transparent;
      height: 3vh !important;
      width: 6vw;
      border: none !important;
      font-size: 1vw;
      //color: white;
      font-weight: bold;
      padding: 0 2vw;
      text-align: right;
    }

    ::v-deep .el-select .el-input .el-select__caret {
      color: #000000;
    }

    ::v-deep .el-input__suffix {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .communicityFeedback {
      //z-index: 8;
      cursor: pointer;
      font-size: 1vw;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      font-weight: bold;
      color: white;
      //color: #2f6eff;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      /* Vertically center the content */
      border-radius: 9.1px;
      padding: 2.46242274412855vh 0.5vw;
      height: 4.56242274412855vh;
      //border: #2f6eff 1px solid;
      //background: rgba(255, 255, 255,0.9);
      margin-right: 1.00065337954939vw;
      overflow: hidden;
      /* Add overflow property */
      display: flex;

      .net {
        background-image: url("../assets/feedback.png");
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        background-color: transparent;
        /* 这里设置背景颜色为透明 */
        width: 20px;
        height: 20px;
      }
    }

    .communicityFeedback:hover {
      //background: #bfd8f9;
      color: #2f6eff;
    }

    .communicityGPT {
      //z-index: 8;
      cursor: pointer;
      font-size: 1vw;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      font-weight: bold;
      //color: #2f6eff;
      //color: white;
      //background:#2sf6eff;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      /* Vertically center the content */
      //border-radius: 9.1px;
      padding: 2.46242274412855vh 1vw;
      height: 4.56242274412855vh;
      //border: #2f6eff 1px solid;
      //margin-right: 1.00065337954939vw;
      overflow: hidden;
    }

    //.communicityGPT:hover {
    //
    //  //background: #bfd8f9;
    //  border-bottom: #1b1e76 3px solid;
    //  color: #1b1e76;
    //}

    .communicity {
      //z-index: 8;
      cursor: pointer;
      font-size: 1vw;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      font-weight: bold;
      //color: white;
      //color: #2f6eff;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      /* Vertically center the content */
      //border-radius: 9.1px;
      padding: 2.46242274412855vh 0.5vw;
      height: 4.56242274412855vh;
      //border: #2f6eff 1px solid;
      margin-right: 1.00065337954939vw;
      overflow: hidden;
      /* Add overflow property */
    }

    .communicity:hover {
      //background: #bfd8f9;
      border-bottom: #1b1e76 3px solid;
      color: #1b1e76;
    }

    .loginUser {
      //z-index: 8;
      //border: #2F6EFF 1px solid;
      //border-radius: 9.1px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      /* Vertically center the content */
      font-size: 1vw;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      color: white;
      line-height: 3.33745364647713vh;
      text-align: center;
      width: fit-content;
      height: 4.56242274412855vh;
      background: transparent;

      .flex {
        display: flex;
        align-items: center;
        height: 32px;
        margin-top: 12px;

        img.icon {
          width: 14px;
          height: 14px;
          margin-right: 5px;
        }

        .icon.hover {
          display: none;
        }
      }
    }

    .login {
      //z-index: 8;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      /* Vertically center the content */
      font-size: 1vw;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      font-weight: bold;
      //color: #2f6eff;
      //color: white;
      line-height: 3.33745364647713vh;
      text-align: center;
      //border-radius: 9.1px;
      width: fit-content;
      padding: 2.46242274412855vh 1vw;
      height: 4.56242274412855vh;
      //background: #2f6eff;
      //border: #2f6eff 1px solid;
    }

    //.login:hover {
    //  //background: #bfd8f9;
    //  color: #1b1e76;
    //  border-bottom: #1b1e76 3px solid;
    //}
  }
}

.layerModel {
  display: flex;
  justify-content: space-between;

  //background-color: white;
  .searchnew {
    background-color: #d7d7d7;
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    z-index: 99;

    .searchBack {
      margin-top: 108px;
      //background-color: rgba(102, 102, 102, 0.2);
      display: block;
      padding: 0 15px;
      row-gap: 15px;
      list-style-type: none;
      height: 90vh;
      overflow-y: auto;
    }

    .searchBackno {
      display: block;
      margin-top: 108px;
      padding: 15px 25px;
      font-weight: bold;
      text-align: center;
    }

    .searchContent {
      cursor: pointer;
      //background: #e5ebfa;
      border: white 1px solid;
      background-color: #f2f2f2;
      //box-shadow: 5px 0 14px 0px #e5ebfa;
      padding: 10px;
      height: 100%;
      border-radius: 9px;
      margin-bottom: 15px;
      //color: white;

      .title1 {
        font-size: 14px;
        font-weight: bold;
        line-height: 22px;
      }

      .title2 {
        font-size: 12px;
        margin-top: 5px;
        line-height: 20px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        /* 限制在一个块元素显示的文本的行数 */
        overflow: hidden;
        text-overflow: ellipsis;
        height: 40px;
      }
    }

    .search {
      margin: 35px 5vw 25px -5vw;
      display: flex;
      border-radius: 9px;
      width: 90vw;
      background-color: white;

      ::v-deep .el-input {
        border-radius: 9px;
        width: 80vw;

        font-size: 14px;
      }

      ::v-deep .el-input__inner {
        border-radius: 9px;
        height: 45px !important;
        border: white 1px solid !important;
        background-color: transparent !important;
      }

    }
  }

  .userName {
    color: black;
    font-size: 14px;
    line-height: 1.3;
    text-align: left;
    margin-left: 10px;
    max-width: 50px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .leftLayer {
    cursor: pointer;
    width: 80px;
    height: 20px;
    background-image: url("../assets/GPTLOGO.png");
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    background-color: transparent;
    /* 这里设置背景颜色为透明 */
    //border: #2c3e50 1px solid;
  }

  .rightLayer {
    margin-top: -0.89443757725587vh;
    width: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;

    /* Vertically center the content */
    .communicity {
      z-index: 8;
      cursor: pointer;
      font-size: 14px;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      font-weight: 400;
      color: white;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      /* Vertically center the content */
      border-radius: 9.1px;
      padding: 2.46242274412855vh 1.19896013864818vw;
      height: 4.56242274412855vh;
      border: white 1px solid;
      margin-right: 1.00065337954939vw;
      overflow: hidden;
      /* Add overflow property */
    }

    //.communicity:hover {
    //  background: rgba(255, 255, 255, 0.5);
    //}
    .communicitynet {
      z-index: 8;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      /* Vertically center the content */
      font-size: 14px;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      font-weight: 400;
      color: white;
      line-height: 45px;
      text-align: center;
      border-radius: 9.1px;
      width: fit-content;
      padding: 5px;
      height: 35px;

      ::v-deep .el-input {
        border-radius: 9px;
        width: 75px;
        font-size: 14px;
        color: black;
      }

      ::v-deep .el-select .el-input .el-select__caret {
        color: black;
      }

      ::v-deep .el-input__inner {
        border-radius: 9px;
        color: black;
        height: 5vh !important;
        border: none !important;
        background-color: transparent !important;
      }

      .net {
        background-image: url("../assets/netModel.png");
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        background-color: transparent;
        /* 这里设置背景颜色为透明 */
        width: 14px;
        height: 14px;
      }
    }

    //.communicitynet:hover {
    //  color: #2f6eff;
    //  background: rgba(255, 255, 255, 0.5);
    //  border: #2f6eff 1px solid;
    //}

    .loginUser {
      z-index: 8;
      //border: #2F6EFF 1px solid;
      border-radius: 9.1px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      /* Vertically center the content */
      font-size: 14px;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      color: white;
      line-height: 3.33745364647713vh;
      text-align: center;
      width: fit-content;
      height: 4.56242274412855vh;
      background: transparent;

      .flex {
        display: flex;
        align-items: center;
        height: 32px;
        margin-top: 12px;

        img.icon {
          width: 14px;
          height: 14px;
          margin-right: 5px;
        }

        //.icon.hover {
        //  display: none;
        //}
      }
    }

    .login {
      z-index: 8;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      /* Vertically center the content */
      font-size: 14px;
      font-family: Sarial, sans-serif, "Microsoft Yahei";
      color: #ffffff;
      line-height: 15px;
      text-align: center;
      border-radius: 9.1px;
      width: fit-content;
      padding: 10px;
      height: 35px;
      font-weight: bold;
      //background: white;
      //border: #2f6eff 1px solid;
    }

    //.login:hover {
    //  color: #2f6eff;
    //  background: rgba(255, 255, 255, 0.5);
    //  border: #2f6eff 1px solid;
    //}
  }
}

.layer2 {
  .title1 {
    margin: 0 auto;
    width: fit-content;
    height: 23px;
    font-size: 23px;
    font-family: Sarial, sans-serif, "Microsoft Yahei";
    font-weight: 500;
    color: #111111;
    line-height: 8.23733003708282vh;
  }

  .title2 {
    margin: 35px auto 0 auto;
    width: fit-content;
    height: 17px;
    font-size: 14px;
    font-family: Sarial, sans-serif, "Microsoft Yahei";
    font-weight: 400;
    color: #111111;
    line-height: 24px;
  }

  .title3 {
    display: flex;
    text-align: center;
    margin: 20px auto 0 auto;
    width: fit-content;
    height: 35px;
    font-size: 8px;
    font-family: Sarial, sans-serif, "Microsoft Yahei";
    font-weight: bold;
    color: #2f6eff;
    line-height: 22px;
  }
}

.layer3 {
  position: absolute;
  display: flex;
  bottom: 15px;
  opacity: 1;
  width: 90%;
  justify-content: center;

  .communicity {
    //z-index: 8;
    cursor: pointer;
    font-size: 16px;
    font-family: Sarial, sans-serif, "Microsoft Yahei";
    font-weight: 400;
    color: #2f6eff;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    /* Vertically center the content */
    border-radius: 9.1px;
    width: fit-content;
    margin: 0 15px;
    padding: 10px 4.6875vw;
    height: 35px;
    border: #2f6eff 1px solid;
    overflow: hidden;
    /* Add overflow property */
  }

  .communicityGpt {
    //z-index: 8;
    cursor: pointer;
    font-size: 16px;
    font-family: Sarial, sans-serif, "Microsoft Yahei";
    font-weight: 400;
    color: white;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    /* Vertically center the content */
    border-radius: 9.1px;
    width: fit-content;
    margin: 0 15px;
    padding: 10px 4.6875vw;
    height: 35px;
    background-color: #2f6eff;
    border: #2f6eff 1px solid;
    overflow: hidden;
    /* Add overflow property */
  }

}

</style>
